import ContentModal from 'components/GlobalModals/ContentModal/ContentModal';
import { withContentModalProps } from 'viewModel/globalModals/contentModal/withContentModalProps';

export default withContentModalProps(ContentModal);
